export default {
  accounts: [],
  phone_types : [],
  autocomplete_data : [],
  autocomplete_selected : {},
  verticals : [],
  vertical_selected : {},
  countries : [],
  sic_codes:[],
  phone_codes:[],
  sic_codes_selected:{},
  phone_codes_selected:{},
  countries_selected : {},
  head_office_country_selected : {},
  registered_office_country_selected : {},
  company_or_registration_no:[],
  company_or_registration_no_selected : {},
}
